import React from 'react';

const Modal = ({ show, onClose, title, children, maxWidth = 'max-w-md' }) => {
    if (!show) return null;

    return (
        <div className="fixed inset-0 bg-black bg-opacity-75 flex items-center justify-center z-50 p-4">
            <div className={`bg-gray-900 shadow-xl p-6 w-full ${maxWidth} animate-fade-in-up`}>
                <div className="flex justify-between items-center pb-3 border-b border-gray-700">
                    <h2 className="text-2xl font-bold text-white">{title}</h2>
                    <button onClick={onClose} className="text-gray-400 hover:text-white text-3xl leading-none">
                        &times;
                    </button>
                </div>
                <div className="py-4">
                    {children}
                </div>
                <div className="flex justify-end pt-3 border-t border-gray-700">
                    <button
                        onClick={onClose}
                        className="bg-[#141414] hover:bg-[#333] text-white font-bold py-2 px-4 transition duration-300 ease-in-out"
                    >
                        Close
                    </button>
                </div>
            </div>
        </div>
    );
};

export default Modal;
